module.exports = __webpack_public_path__ + "static/google-play-badge-a2340a07cb07ec1c42e89dbc002ced7c.svg";